import { CheckCircle2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { formatPrice } from "../../../lib/formatPrice";
import LabBookingLayout from "../components/LabBookingLayout";
import { useLabBooking } from "../context/LabBookingContext";

const OrderConfirmedPage = () => {
  const navigate = useNavigate();
  const { completedOrder, collectionType } = useLabBooking();

  const orderId    = completedOrder?.orderId ?? "—";
  const amountPaid = formatPrice(completedOrder?.amount ?? 0);
  const isHome     = collectionType !== "lab";

  return (
    <LabBookingLayout>
      <div className="max-w-md mx-auto bg-white rounded-2xl border border-gray-100 p-8 mt-8 text-center">
        <div className="w-14 h-14 rounded-full bg-[#EEF9F4] flex items-center justify-center mx-auto mb-4">
          <CheckCircle2 className="text-[#13B58E]" size={30} />
        </div>
        <h2 className="text-[20px] font-extrabold text-[#191C1D]">Order Confirmed! 🎉</h2>
        <p className="text-[12px] text-[#6B7A99] mt-1 mb-5">
          {isHome
            ? "Your booking is confirmed. Sample collection will be done at your address."
            : "Your booking is confirmed. Please visit the lab at your selected time slot."}
        </p>

        <div className="bg-[#F8FAFB] rounded-xl p-4 grid grid-cols-3 gap-2 text-left mb-5">
          <div>
            <p className="text-[10px] text-[#9AA6A4] uppercase">Order ID</p>
            <p className="text-[12px] font-semibold text-[#191C1D]">#{orderId}</p>
          </div>
          <div>
            <p className="text-[10px] text-[#9AA6A4] uppercase">
              {isHome ? "Collection Date" : "Visit Date"}
            </p>
            <p className="text-[12px] font-semibold text-[#191C1D]">{completedOrder?.date || "—"}</p>
          </div>
          <div>
            <p className="text-[10px] text-[#9AA6A4] uppercase">Time Slot</p>
            <p className="text-[12px] font-semibold text-[#191C1D]">{completedOrder?.time || "—"}</p>
          </div>
        </div>

        <p className="text-[12px] text-[#6B7A99] mb-5">
          Amount Paid: <span className="font-bold text-[#191C1D]">₹{amountPaid}</span>
        </p>

        <div className="bg-[#0F172A] rounded-2xl p-5 text-left">
          <span className="inline-block text-[10px] font-semibold text-[#13B58E] bg-white/10 px-2 py-1 rounded-full mb-2">
            Reports ready in 24-48 hrs
          </span>
          <p className="text-white text-[13px] font-semibold mb-1">
            Download HealthismPlus App to View Your Reports
          </p>
          <p className="text-white/60 text-[11px] mb-4">
            Your lab reports will be available in the app. Track results, set health goals, and store all your reports securely in one place.
          </p>
          <div className="flex gap-2">
            <a href="https://onelink.to/r6c4yw" target="_blank" rel="noopener noreferrer"
              className="flex-1 bg-white text-[#191C1D] text-[12px] font-semibold py-2 rounded-lg text-center">
              App Store
            </a>
            <a href="https://onelink.to/r6c4yw" target="_blank" rel="noopener noreferrer"
              className="flex-1 bg-white text-[#191C1D] text-[12px] font-semibold py-2 rounded-lg text-center">
              Google Play
            </a>
          </div>
        </div>

        <button
          onClick={() => navigate("/")}
          className="w-full bg-[#13B58E] text-white text-[14px] font-semibold py-3 rounded-full mt-5 hover:bg-[#0fa07d] transition"
        >
          Book More Tests
        </button>
      </div>
    </LabBookingLayout>
  );
};

export default OrderConfirmedPage;
